module.exports = __webpack_public_path__ + "img/address-sf.4c684c82.svg";